/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core';
import { bool, object } from 'prop-types';

import OfferInboxContainer from '../GraphqlHomePage/Partials/PersonalizedOfferInbox/OfferInboxContainer';
import { setOfferInboxDrawerOpen } from '../../../../state/ducks/App/App-Actions';
import { emitCustomTrackingEvent } from '../../../../state/ducks/TagManager/ducks/ClickStreamEvents/ClickStreamEvent-Actions';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getOfferInboxData } from '../../../../state/ducks/App/App-Selectors';
import { OFFER_INBOX_HEADER_ITEM, buildOfferInboxBannerEvent } from '../GraphqlHomePage/Partials/PersonalizedOfferInbox/offerInboxTracking';

const useStyles = makeStyles((theme) => ({
    root: {
        fontSize: '12px',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        textAlign: 'center',
    },
    gridStyle: {
        gridArea: '1/4',
        width: '30px',
        justifyContent: 'center',
        alignItems: 'center',
    },
    img: {
        maxHeight: '29px !important',
        position: 'relative',
        left: '6px',
        [theme.breakpoints.up(600)]: {
            right: '8px',
            left: 0,
        },
    },
}));

const OfferInboxLink = ({
    linkObj, isFromMobile,
}) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const instanceId = 'OfferInboxLink';
    const offerInboxABVariant = useSelector(getOfferInboxData)?.abTestVariant;
    const shouldRenderOfferInbox = (!offerInboxABVariant || offerInboxABVariant === 'OfferInbox');

    const imgUrl = isFromMobile ? linkObj?.icon?.url : linkObj?.icon;
    if (!imgUrl || !shouldRenderOfferInbox) return null;

    const handleClick = () => {
        dispatch(trackEvent(buildOfferInboxBannerEvent({
            bannerItemName: OFFER_INBOX_HEADER_ITEM,
            clickText: 'Deals',
        })));

        dispatch(emitCustomTrackingEvent({
            action: 'Click',
            eventSubType: 'feature-tracking',
            label: 'offer-inbox-deals-offer',
        }));
        dispatch(setOfferInboxDrawerOpen({ [instanceId]: true }));
    };

    return (
        <>
            <div id="offer-inbox-link" className={`${classes.root} ${isFromMobile ? classes.gridStyle : ''}`} onClick={handleClick} role="button" onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleClick()} tabIndex={0}>
                <img className={classes.img} src={imgUrl} alt={isFromMobile ? 'Deals' : ''} aria-hidden={!isFromMobile} />
                {!isFromMobile && <span>Deals</span>}
            </div>
            <OfferInboxContainer instanceId={instanceId} />
        </>
    );
};

OfferInboxLink.propTypes = {
    linkObj: object.isRequired,
    isFromMobile: bool,
};

OfferInboxLink.defaultProps = {
    isFromMobile: false,
};
export default OfferInboxLink;
